export const Environment = {
  name: 'production',
  production: true,
  sentryEnable: true,
  showSentryDialog: false,
  apiUrl: 'https://portal-backend-prod.cueportalservice.cueaudio.com/v1',
  fileUploadBucketName: "cueaudio-fileupload",
  s3CdnUrl: "https://fileupload.cueaudio.com"
};
